export default "﻿<div class=\"kanban_Root\"> \n    <div data-dojo-attach-point=\"dashboardsContainerNode\"></div>\n</div>"